<div class="content relative flex flex-col items-center justify-center py-8 px-4">
  <mat-icon fontSet="material-icons-round">info_outline</mat-icon>
  <h3>Sesión a punto de expirar</h3>
  <p>Por motivos de seguridad, la sesión será cerrará pronto debido a inactividad. ¿Desea continuar conectado?</p>
  <p class="time">{{ displayTime }}</p>

  <div class="flex items-center justify-center mt-4 gap-6">
    <button mat-stroked-button color="warn" (click)="logout()">Cerrar sesión</button>
    <button mat-stroked-button color="primary" (click)="extendSession()">Extender sesión</button>
  </div>
</div>
<div class="close absolute top-2 right-2 p-2">
  <mat-icon (click)="extendSession()" fontSet="material-icons-round">close</mat-icon>
</div>
